module.exports = __webpack_public_path__ + "5eed650980f1eaf71a319ebe9ce27b68.svg";